var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54447 15.7509C5.51585 14.7517 5.00103 13.4421 5 12.1324C4.99897 10.8188 5.51379 9.50513 6.54447 8.50188C8.60272 6.49937 11.9408 6.49937 14.0001 8.50188C16.0584 6.49937 19.3965 6.49937 21.4557 8.50188C22.5492 9.56521 23.062 10.979 22.994 12.3707C22.9333 13.6002 22.4205 14.8118 21.4557 15.7509L14.0001 23L6.54447 15.7509Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8a40826b7e461ac222ca1b747a4614ae.svg";
export { ForwardRef as ReactComponent };